export { default } from './EmailConsentScreen';
